import './uitgelichte-producten.scss'

// Market filter: show only products tagged with the chosen application.
document.querySelectorAll('[data-uitgelichte-producten-filter]').forEach((section) => {
	const select = section.querySelector('[data-uitgelichte-producten-select]');
	const items = section.querySelectorAll('.o-uitgelichteProducten__item');

	if (!select) {
		return;
	}

	select.addEventListener('change', () => {
		const value = select.value;

		items.forEach((item) => {
			const applications = (item.dataset.applications || '').split(' ');
			item.classList.toggle('-is-hidden', value !== '' && !applications.includes(value));
		});
	});
});
